import { LocalDate } from '../../core/model/local-date';

export class LettingShowing {
  constructor(data?: any) {
    if (data) {
      this.id = data.id;
      this.name = data.name || '';
      this.email = data.email || '';
      this.phone = data.phone || '';
      this.leaseEndDate = data.leaseEndDate ? LocalDate.fromDate(data.leaseEndDate) : null;
    }
  }

  id: string;
  name: string;
  email: string;
  phone: string;
  leaseEndDate: LocalDate;
}
